import { createFileRoute } from "@tanstack/react-router";
import { fleaMarketItemDetailQueryOptions } from "~/features/fleamarket/api";
import { FleaMarketPurchaseConfirmationTemplate } from "~/features/fleamarket/FleaMarketPurchaseConfirmationTemplate";

export const Route = createFileRoute(
  "/_authenticated/fleamarket/purchase-confirmation/$itemId",
)({
  loader: ({ context: { queryClient }, params: { itemId } }) =>
    queryClient
      .ensureQueryData(fleaMarketItemDetailQueryOptions(itemId))
      .catch(() => undefined),
  component: FleaMarketPurchaseConfirmationTemplate,
});
